import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
`;


function WorkPageEditResume(props) {
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodSettings/></div>
            <div className="text">موقعیت های شغلی</div>
          </div>
      </div>
      <div className="content">
        
      </div>
    </StyleCss>
  )
}
export default WorkPageEditResume;